import React from 'react';

// hook to scroll to an element on render
function useScrollOnRender(shouldScroll = false, smooth = false, offset = 0) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (shouldScroll && ref.current) {
      const args = smooth ? { behavior: 'smooth' } : {};
      ref.current.scrollIntoView({ block: 'nearest', ...args });
      const closest = ref.current.closest('.overflow-y-scroll');
      if (closest) {
        closest.scrollBy({ top: offset, ...args });
      }
    }
  }, []);

  return ref;
}

export default useScrollOnRender;
